<template>
    <div class="scroll-content-horizonal section-team" ref="scrollContent">
        <Collapse v-if="publicList && publicList.length">
            <template slot="title">
                公共组
            </template>
            <template slot="content">
                <TeamNode 
                    v-for="(item, index) in publicList"
                    @handleExpand="handleExpand"
                    @handleChecked="handleChecked"
                    :data="item"
                    :key="index"
                    :withMembers="withMembers"/>
            </template>
        </Collapse>
        <Collapse v-if="privateList && privateList.length">
            <template slot="title">
                个人组
            </template>
            <template slot="content">
                <TeamNode 
                    v-for="(item, index) in privateList"
                    @handleExpand="handleExpand"
                    @handleChecked="handleChecked"
                    :data="item"
                    :key="index"
                    :withMembers="withMembers"/>
            </template>
        </Collapse>
        <Load 
      		:hasData="!!privateList.length && !!publicList.length"
            :hasMore="hasMore"
			:loading="loading" 
			@on-load="getTeamList"/>
        <Empty v-if="!loading && !hasMore && !privateList.length && !publicList.length"/>
    </div>
</template>
<script>
    /**
     * 内部群
     *  */
    import TeamNode from './section-team-node'
    import scroll from '../mixins/scroll'
    import section from '../mixins/section'
    import ajax from '../../../../utils/ajax'
    import Empty from '../../../base/empty/'
    import Collapse from '../../../base/collapse'
    import Message from '../../../base/message/'
    import { t } from '../../../../locale/'

    export default {
        name: 'SectionTeam',
        mixins: [scroll, section],
        inject: ['root'],
        data() {
            return {
                publicList: [],
                privateList: []
            }
        },
        props: {
            withMembers: {
                type: Boolean,
                default: false
            }
        },
        components: {
            TeamNode,
            Collapse,
            Empty
        },
        methods: {
            getTeamList(deptId) { // 拉取当前组
                const _this = this
                this.loading = true
                ajax({
                    url: `${this.root.host}/cooperation/rest/v1/candidate/${this.root.qzId}/team/list`,
                    params: {
                        language: _this.root.language
                    },
                    success(res) {
                        let data = JSON.parse(res)
                        if(!Array.isArray(data)) {
                            return _this.handleError()
                        }
                        data.forEach(item => {
                            item.type = 4
                            item.expand = false
                            item.checked = false
                            item.loading = false
                            item.children = []
                            if(item.teamType === 'PUBLIC') {
                                _this.publicList.push(item)
                            }
                            if(item.teamType === 'PRIVATE') {
                                _this.privateList.push(item)
                            }
                        })
                        _this.hasMore = false
                        _this.page++
                        _this.loading = false
                    },
                    error() {
                        _this.handleError()
                    }
                })
            },
            getMemberList(teamId, params, isSelect) { // 拉取当前内部群成员
                const _this = this
                params && (params.loading = true)
                ajax({
                    url: `${this.root.host}/cooperation/rest/v1/candidate/${this.root.qzId}/team/${teamId}/members`,
                    params: {
                        token: '832eb293-8e5f-486f-a3be-057900b10b7b',
                        keyword: '',
                        page: 1,
                        size: 300,
                        language: _this.root.language,
                        tmp: new Date().valueOf()
                    },
                    success(res) {
                        let data = JSON.parse(res)
                        if(!(data && data.length)) {
                            return _this.handleError(params)
                        }
                        data.forEach(item => {
                            item.checked = !!isSelect || false
                            item.type = 0
                            if(isSelect) {
                                _this.$emit('handleSelected', item)
                            }
                        })
                        params && (params.loading = false)
                        params && (params.children = data)
                    },
                    error() {
                        _this.handleError(params)
                    }
                })
            },
            handleChecked(checked, data) {
                if(data.loading) return
                if(!this.withMembers || data.type === 0) {
                    if(checked && 1 + this.root.selectedCount > this.root.limit) {
                        return Message.warning(t('selectMember.maximum'))
                    }
                    data.checked = checked
                    return this.$emit('handleSelected', data)
                } 
                if(checked && data.count + this.root.selectedCount > this.root.limit) {
                    return Message.warning(t('selectMember.maximum'))
                }
                if(data.children && data.children.length) {
                    data.checked = checked
                    return data.children.forEach((item)=>{
                        item.checked = checked
                        this.$emit('handleSelected', item)
                    })
                } 
                data.expand = true
                return this.getMemberList(data.id, data, true)
            },
            handleExpand(expand, data) {
                data.expand = expand
                if(data.children && data.children.length) return
                this.getMemberList(data.id, data)
            }
        },
        created() {
            this.getTeamList()
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/business/select-member/section/section-team.vue